export const SN_NETSUITE = 'netsuite'
export const NETSUITE_CUSTOMER = `${SN_NETSUITE}/NETSUITE_CUSTOMER`
export const NETSUITE_ORDERS = `${SN_NETSUITE}/NETSUITE_ORDERS`
export const NETSUITE_CURRENT_ORDER = `${SN_NETSUITE}/NETSUITE_CURRENT_ORDER`
export const NETSUITE_TRACKING = `${SN_NETSUITE}/NETSUITE_TRACKING`
export const NETSUITE_LOADING = `${SN_NETSUITE}/NETSUITE_LOADING`
export const NETSUITE_SUBMITTING = `${SN_NETSUITE}/NETSUITE_SUBMITTING`
export const NETSUITE_ERROR = `${SN_NETSUITE}/NETSUITE_ERROR`
export const NETSUITE_CLEAR = `${SN_NETSUITE}/NETSUITE_CLEAR`
